import * as Yup from "yup";

export const PaymentValidationSchema = Yup.object().shape({
  userId: Yup.number().required("User id is required"),
  amount: Yup.number().required("Amount is required"),
});
